import { Icon, Spinner, colorValue } from '@hai/ui-react';
import React from 'react';

interface Busy {
  busy: boolean;
  isActive: boolean;
  activeIcon: string;
  inactiveIcon: string;
}

const BusyIcon: React.FunctionComponent<Busy> = ({ busy, isActive, activeIcon, inactiveIcon }: Busy) => {
  return busy ? (
    <Spinner loopTime={1} style={{ width: '18px', height: '18px' }} />
  ) : (
    <Icon iconname={isActive ? activeIcon : inactiveIcon} color={colorValue('haiui-gray-04')} />
  );
};

export default BusyIcon;
